// Profiles and grouping are restored through the existing owner-scoped list
// reads. This hook owns no preference storage and makes no provider requests.
export function useWatchlistClassifications(userId, rows, enabled) {
  const profiles = Object.fromEntries((userId ? rows || [] : []).filter(row => row.assetProfile).map(row => [row.symbol, row.assetProfile]))
  return { enabled: Boolean(userId && enabled), profiles, pending: false }
}
